export default "__VITE_ASSET__DdtOCFKX__"